<template>
  <transition-group
    v-if="sortedList"
    class="obituary-threaded-comments__list"
    name="threaded-comments-list-item"
    tag="div"
  >
    <threaded-comments-single
      v-for="comment in sortedList"
      :key="comment.id"
      :comment="comment"
      :parent="parent"
    />
  </transition-group>
</template>

<script>
import ThreadedCommentsSingle from './Single.vue';
import { useThreadedComments } from '../../composables/useThreadedComments';

export default {
  name: 'ThreadedCommentsList',

  components: { ThreadedCommentsSingle },

  setup() {
    const { createdComments, hasCreatedComments, sort } = useThreadedComments();
    return { createdComments, hasCreatedComments, sort };
  },

  props: {
    list: {
      type: Array,
      required: true,
    },
    parent: {
      type: Object,
      default: null,
    },
  },

  computed: {
    sortedList() {
      if (!this.hasCreatedComments) {
        return this.list;
      }

      return this.sort(this.list);
    },
  },
};
</script>
